import { ThemeProvider } from '@mui/material/styles';
import { FC } from 'react';
import { AppRouter } from './routes/router';
import { AppContainerProvider } from './services/service.base';
import { theme } from './theme/default';

export const App: FC = () => {
    return (
        <AppContainerProvider>
            <ThemeProvider theme={theme}>
                <AppRouter />
            </ThemeProvider>
        </AppContainerProvider>
    );
};
